import { NodeShape } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Shape/NodeShape';
import { BEEntity } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEEntity';
import { PartShape } from '../../BaseShape/PartShape';
import { MDAConstant } from '../../Base/MDAConstant';
import { BaseElement } from '../../../../../../../api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { BEAttribute } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEAttribute';
import { EntityMethod } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EntityMethod';
import { EnumErrorLevel } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumErrorLevel';
import { ValidationResult } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/ValidationResult';
import { ValidationResultHelper } from '../../Base/ValidationResultHelper';
import { ValidateHelper } from '../../../../Product/IDE/Util/ValidateHelper';
import { MDShape } from '../../BaseShape/MDShape';
import { MDExtendService } from '../../../MD/MDExtendService';
import { Diagram } from '../Diagram';
import { BEComponent } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEComponent';
import { MethodParameter } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/MethodParameter';
import { Double2D } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Base/Double2D';
import { EnumPersistenceStatus } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { EnumDisplayLanguage } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Base/EnumDisplayLanguage';
import { EnumDataType, EnumDataTypeMD } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { DataTypeManager } from '../../../MD/DataTypeManager';
import { ShapeModel } from '../../BaseShape/ShapeModel';
import { MDValidation } from '../../../MD/MDValidation';
import { MDRepository } from '../../../MD/MDRepository';
import { EnumInheritanceModifier } from '../../../../../../../api/com/MetaPattern/MDA/MD/Base/EnumInheritanceModifier';

export class JointEntityShape extends PartShape {
  constructor(attributes?: any, opt?: any) {
    super(attributes, opt);
    // this.id = this.curEntity.designId;
    this.set('type', 'mst.JointEntityShape');
    this.attr({
      '.uml-type-icon': { xlinkHref: '/imgs/icons/icon_Class.png' }
    });
    // 反序列化调用，手工创建的时候不调用
    if (attributes) {
      this.setMD(attributes?.shape, attributes?.model.element, true);
    }
  }

  public setMD(elementShape: NodeShape, element: BEEntity, isFromJSON: boolean) {
    if (element) {
      MDExtendService.setElementListSequence(element.attributes, false);
      MDExtendService.setElementListSequence(element.methods, false);
      element.methods.forEach(method => {
        MDExtendService.setElementListSequence(method.parameters, false);
      });
    }
    this.setBaseMD(elementShape, this.createModel(element, !elementShape.isExpend), isFromJSON);
  }

  public get entity(): BEEntity {
    return this.element() as BEEntity;
  }

  public shapeType(): string {
    return MDAConstant.Type.ADD_ENTITY;
  }

  public doAction(action: string, designId?: string): BaseElement | null {
    let element = super.doAction(action, designId);
    switch (action) {
      // 添加属性
      case 'shape:addAttribute':
        element = this.addAttribute();
        break;
      // 添加方法
      case 'shape:addMethod':
        element = this.addMethod();
        break;
      case 'shape:deleteChild':
        element = this.deleteChild(designId);
        break;
      default:
        break;
    }
    this.refresh();
    return element;
  }

  /** 根据链接的类型，设置鼠标的样式 */
  public setLinkType(linkType: string) {
    if (linkType === MDAConstant.Link.ADD_GENERALIZATION || linkType === MDAConstant.Link.ADD_IMPLEMENT || linkType === MDAConstant.Link.ADD_ASSOCIATION || linkType === MDAConstant.Link.ADD_COMPOSITION || linkType === MDAConstant.Link.ADD_AGGREGATION) {
      this.attr({ '.uml-class-container': { cursor: 'crosshair' }, '.uml-class-name-text': { cursor: 'crosshair' } });
    } else if (linkType === 'nouselink') {
      this.attr({ '.uml-class-container': { cursor: 'not-allowed' }, '.uml-class-name-text': { cursor: 'not-allowed' } });
    } else {
      this.attr({ '.uml-class-container': { cursor: 'move' }, '.uml-class-name-text': { cursor: 'move' } });
    }
  }

  /** 刷新图形 */
  // refresh() {
  //   // TODO : 有的状态需要保存，其他图形并未如此实现
  //   this.setMD(this.shape(), this.entity, false);
  // }

  /**
   * 克隆图形，包括图形内部所有元素，不包括与其他图形的关系
   * @param diagram 克隆后所属的图表
   * @param elements 克隆的所有元数据都插入数组返回
   */
  public cloneShape(diagram: Diagram, elements: Array<BaseElement>): MDShape {
    const jShape = new JointEntityShape();

    const entityShape = new NodeShape();
    entityShape.copyFrom(this.shape(), false);
    MDExtendService.setCreateInfo(entityShape);
    entityShape.startPoint = new Double2D(this.position().x + 20, this.position().y + 20);
    entityShape.diagram_ID = diagram.diagramShape.id;
    diagram.diagramShape.nodeShapes.push(entityShape);

    const newEntity = new BEEntity();
    newEntity.copyFrom(this.entity, false);
    MDExtendService.setCreateInfo(newEntity);
    elements.push(newEntity);
    if (diagram.component instanceof BEComponent) {
      newEntity.component_ID = diagram.component.id;
      diagram.component.entities.push(newEntity);
    }

    this.entity.attributes.forEach(item => {
      if (item.persistenceStatus !== EnumPersistenceStatus.Delete && !item.isAssociation) {
        const attribute = new BEAttribute();
        attribute.copyFrom(item, false);
        MDExtendService.setCreateInfo(attribute);
        attribute.entity_ID = newEntity.id;
        newEntity.attributes.push(attribute);
        elements.push(attribute);
      }
    });

    this.entity.methods.forEach(item => {
      if (item.persistenceStatus !== EnumPersistenceStatus.Delete) {
        const method = new EntityMethod();
        method.copyFrom(item, false);
        MDExtendService.setCreateInfo(method);
        method.entity_ID = newEntity.id;
        newEntity.methods.push(method);
        elements.push(method);
        item.parameters.forEach(parameter => {
          if (parameter.persistenceStatus !== EnumPersistenceStatus.Delete) {
            const newParameter = new MethodParameter();
            newParameter.copyFrom(parameter, false);
            MDExtendService.setCreateInfo(newParameter);
            newParameter.entityMethod_ID = method.id;
            method.parameters.push(newParameter);
            elements.push(newParameter);
          }
        });
      }
    });

    entityShape.elementId = newEntity.designId;
    jShape.setMD(entityShape, newEntity, false);
    diagram.cells.push(jShape);
    return jShape;
  }

  public addChildClone(element: BaseElement, elements: Array<BaseElement>): BEAttribute | EntityMethod | null {
    let newElement: BEAttribute | EntityMethod | null = null;
    if (element instanceof BEAttribute) {
      newElement = new BEAttribute();
      newElement.copyFrom(element, false);
      MDExtendService.setCreateInfo(newElement);
      newElement.entity_ID = this.entity.id;
      this.entity.attributes.push(newElement);
      this.model().compartments[0].push(newElement);
      elements.push(newElement);
    } else if (element instanceof EntityMethod) {
      newElement = new EntityMethod();
      newElement.copyFrom(element, false);
      MDExtendService.setCreateInfo(newElement);
      newElement.entity_ID = this.entity.id;
      this.entity.methods.push(newElement);
      this.model().compartments[1].push(newElement);
      elements.push(newElement);
      element.parameters.forEach(parameter => {
        const newParameter = new MethodParameter();
        newParameter.copyFrom(parameter, false);
        MDExtendService.setCreateInfo(newParameter);
        newParameter.entityMethod_ID = newElement.id;
        (newElement as EntityMethod).parameters.push(newParameter);
        elements.push(newParameter);
      });
    }
    return newElement;
  }

  protected getDisplayTitle(element: BaseElement) {
    let title = element.displayName;
    if (element instanceof BEAttribute) {
      if (this.displayLanguage === EnumDisplayLanguage.English) {
        title = `${element.name}:${this.getDataType(element.dataType, element.referenceType)}`;
      } else {
        title = `${element.displayName}:${this.getDataType(element.dataType, element.referenceType)}`;
      }
    } else if (element instanceof EntityMethod) {
      if (this.displayLanguage === EnumDisplayLanguage.English) {
        title = `${element.name}:${this.getDataType(element.returnDataType, element.returnReferenceType)}`;
      } else {
        title = `${element.displayName}:${this.getDataType(element.returnDataType, element.returnReferenceType)}`;
      }
    } else {
      if (this.displayLanguage === EnumDisplayLanguage.English) {
        title = element.name;
      } else {
        title = element.displayName;
      }
    }
    return title;
  }

  private addAttribute(): BEAttribute {
    const attribute = MDRepository.createBEAttribute(this.entity);
    MDExtendService.setElementListSequence(this.entity.attributes, true);
    this.model().compartments[0].push(attribute);
    return attribute;
  }

  private addMethod(): EntityMethod {
    const method = MDRepository.createEntityMethod(this.entity);
    MDExtendService.setElementListSequence(this.entity.methods, true);
    this.model().compartments[1].push(method);
    return method;
  }

  /** 删除子元素及对应的行 */
  private deleteChild(designId: string): BaseElement | null {
    let element: BaseElement = null;
    element = this.entity.attributes.find(item => item.designId === designId);
    if (!element) {
      element = this.entity.methods.find(item => item.designId === designId);
    }
    if (element) {
      // 新建状态的，需要从元数据中删除
      if (element.persistenceStatus === EnumPersistenceStatus.Create) {
        if (element instanceof BEAttribute) {
          this.entity.attributes.splice(this.entity.attributes.findIndex(item => item.designId === element.designId), 1);
        } else if (element instanceof EntityMethod) {
          this.entity.methods.splice(this.entity.methods.findIndex(item => item.designId === element.designId), 1);
        }
      } else {
        element.persistenceStatus = EnumPersistenceStatus.Delete;
      }
      return this.deleteRow(designId);
    }
    return null;
  }

  /** 设置图形的Model */
  private createModel(entity: BEEntity, isCollapse = false): ShapeModel {
    const model = new ShapeModel(entity, isCollapse);
    model.addCompartment(entity.attributes.filter(item => item.persistenceStatus !== EnumPersistenceStatus.Delete && !item.isAssociation));
    model.addCompartment(entity.methods.filter(item => item.persistenceStatus !== EnumPersistenceStatus.Delete));
    return model;
  }

  /**
   * 校验模型
   * 1. 实体
   *    - 不能同时有多个基类
   *    - 必须指定标题属性
   * 2. 属性
   *    - 必须选择引用数据类型
   *    - 特定数据类型（数值、布尔）及枚举不能为空
   *    - 不能存在同名属性
   *    - 数据类型要求必须设置缺省值
   *    - 为枚举类型时必须设置缺省值
   *    - 为计算属性时必须设置计算表达式
   * 3. 方法
   *    - 必须选择返回值引用数据类型
   *    - 不能存在同名方法
   *    - 参数必须选择引用数据类型
   *    - 方法内不能存在同名参数
   */
  public validate(): Array<ValidationResult> {
    const errors = super.validate();
    const entityDesignId = this.entity.designId;
    MDValidation.validateBaseElement(this.entity, this.entity.designId, true, errors);
    if (this.entity.subGenerations.length > 1) {
      errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, entityDesignId, entityDesignId, `实体 [${this.entity.displayName}] 不能同时有多个基类`));
    }
    if (this.entity.inheritanceModifier !== EnumInheritanceModifier.Abstract && !this.hasTitleAttribute(this.entity)) {
      errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, entityDesignId, entityDesignId, `实体 [${this.entity.displayName}] 必须指定标题属性`));
    }
    this.entity.attributes.forEach((element) => {
      MDValidation.validateBaseElement(element, entityDesignId, true, errors);
      if ((element.dataType === EnumDataType.Reference || element.dataType === EnumDataType.UniqueKey) && !ValidateHelper.IsNotNullOrEmpty(element.referenceType)) {
        errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, entityDesignId, element.designId, `实体 [${this.entity.displayName}] 的属性 [${element.displayName}] 必须选择引用数据类型`));
      }
      if ((!DataTypeManager.instance.isNullable(element.dataType) || ValidateHelper.IsEnum(element.dataType, element.referenceType)) && element.isNullable) {
        errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, entityDesignId, element.designId, `实体 [${this.entity.displayName}] 的属性 [${element.displayName}] 不能为空`));
      }
      if (this.entity.attributes.find(item => element.designId !== item.designId && element.name === item.name)) {
        errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, entityDesignId, element.designId, `实体 [${this.entity.displayName}] 不能存在同名属性 [${element.name}]`));
      }
      if (!element.isCollection && !DataTypeManager.instance.isNullable(element.dataType) && !ValidateHelper.IsNotNullOrEmpty(element.defaultValue)) {
        errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, entityDesignId, element.designId, `实体 [${this.entity.displayName}] 的属性 [${element.displayName}] 数据类型要求必须设置缺省值`));
      }
      if (!element.isCollection && ValidateHelper.IsEnum(element.dataType, element.referenceType) && !ValidateHelper.IsNotNullOrEmpty(element.defaultValue)) {
        errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, entityDesignId, element.designId, `实体 [${this.entity.displayName}] 的属性 [${element.displayName}] 为枚举类型时必须设置缺省值`));
      }
      if (element.isCalculate && !ValidateHelper.IsNotNullOrEmpty(element.calculateExpress)) {
        errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, entityDesignId, element.designId, `实体 [${this.entity.displayName}] 的属性 [${element.displayName}] 为计算属性时必须设置计算表达式`));
      }
    });

    this.entity.methods.forEach((element) => {
      MDValidation.validateBaseElement(element, entityDesignId, true, errors);
      if ((element.returnDataType === EnumDataType.Reference || element.returnDataType === EnumDataType.UniqueKey) && !ValidateHelper.IsNotNullOrEmpty(element.returnReferenceType)) {
        errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, entityDesignId, element.designId, `实体 [${this.entity.displayName}] 的方法 [${element.displayName}] 必须选择返回值引用数据类型`));
      }
      if (this.entity.methods.find(item => element.designId !== item.designId && element.name === item.name)) {
        errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, entityDesignId, element.designId, `实体 [${this.entity.displayName}] 不能存在同名方法 [${element.name}]`));
      }
      element.parameters.forEach((parameter) => {
        MDValidation.validateBaseElement(parameter, entityDesignId, false, errors);
        if ((parameter.dataType === EnumDataType.Reference || parameter.dataType === EnumDataType.UniqueKey) && !ValidateHelper.IsNotNullOrEmpty(parameter.referenceType)) {
          errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, entityDesignId, parameter.designId, `实体 [${this.entity.displayName}] 方法 [${element.displayName}] 的参数 [${parameter.displayName}] 必须选择引用数据类型`));
        }
        if (element.parameters.find(item => parameter.designId !== item.designId && parameter.name === item.name)) {
          errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, entityDesignId, parameter.designId, `实体 [${this.entity.displayName}] 方法 [${element.displayName}] 不能存在同名参数 [${parameter.name}]`));
        }
      });
    });
    return errors;
  }

  private hasTitleAttribute(entity: BEEntity): boolean {
    let hasTitle = false;
    if (entity !== null) {
      for (const attr of entity.attributes) {
        if (attr.isTitle) {
          hasTitle = true;
          break;
        }
      }
      if (!hasTitle && entity.superEntity !== null) {
        hasTitle = this.hasTitleAttribute(entity.superEntity);
      }
    }
    return hasTitle;
  }
}
